'use strict';

/* DB-0042 — 3-fuer-2-modal-redesign (Mobile-Phase)
 * ablyftTools comes from the ABlyft wrapper — do not redeclare it. */

(() => {
  const sizeCache = {};
  const fetchSizes = (handle) => {
    if (!sizeCache[handle]) {
      sizeCache[handle] = fetch('/products/' + handle + '.js')
        .then((r) => (r.ok ? r.json() : Promise.reject()))
        .then((p) => {
          const names = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
          let idx = names.findIndex((n) => /größe|groesse|size/i.test(n || ''));
          if (idx === -1) idx = 0;
          const sizes = [];
          (p.variants || []).forEach((v) => {
            const val = (v.options && v.options[idx]) || v['option' + (idx + 1)] || v.title;
            if (!val) return;
            let s = sizes.find((x) => x.value === val);
            if (!s) {
              s = { value: val, available: false };
              sizes.push(s);
            }
            if (v.available) s.available = true;
          });
          return sizes;
        })
        .catch(() => null);
    }
    return sizeCache[handle];
  };

  // Größen-Reihe pro Karte — reine Anzeige, ATC öffnet weiter den Quick-Buy
  function addSizes(dialog) {
    dialog.querySelectorAll('product-card[handle]').forEach((card) => {
      const info = card.querySelector('.product-card__info');
      if (!info || info.querySelector('.as-db-0042-sizes')) return;
      fetchSizes(card.getAttribute('handle')).then((sizes) => {
        if (!sizes || sizes.length < 2) return;
        const row = document.createElement('div');
        row.className = 'as-db-0042-sizes';
        sizes.forEach((s) => {
          const span = document.createElement('span');
          span.className = 'as-db-0042-size' + (s.available ? '' : ' as-db-0042-size-out');
          span.textContent = s.value;
          row.appendChild(span);
        });
        info.insertBefore(row, info.firstChild);
      });
    });
  }

  // Trigger on the modal's LAST element (footer button), not the dialog —
  // ABlyft observes mid-parse, earlier nodes exist before the block is done.
  function changeModal(continueBtn) {
    try {
      const dialog = continueBtn.closest('.sale-event-modal__dialog');
      if (!dialog || dialog.classList.contains('as-db-0042')) return;
      dialog.classList.add('as-db-0042');
      const modal = dialog.closest('.sale-event-modal');

      // Zählbasis wie im Theme (sale-event-modal.js): die Aktions-Produkt-IDs
      // stehen in data-target-products am Modal, gezählt wird deren
      // Cart-Menge — NICHT nur die im Modal gelisteten Vorschlagskarten.
      const targetIds =
        modal && modal.dataset.targetProducts ? modal.dataset.targetProducts.split(',').map(Number) : null;
      const handles = Array.prototype.map.call(dialog.querySelectorAll('product-card[handle]'), (c) =>
        c.getAttribute('handle'),
      );

      addSizes(dialog);
      modal.addEventListener('sale-event:products-change', () => addSizes(dialog));
    } catch (e) {
      console.error('[DB-0042]', e);
    }
  }

  changeModal(document.querySelector('.sale-event-modal [data-sale-event-continue]'))
})();
